module.exports = __webpack_public_path__ + "static/product-2-c001aa205246ff0d329c6bc45ea0db80.png";